import React, { useState } from "react";
import className from "classnames";
import styles from "components/UI/Tabs/Tabs.module.scss";
import { Globals } from "utils/styleconfig";
import Button from "components/UI/Button/Button";
import { RiCloseLine } from "react-icons/ri";

const Tabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].key);

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.tabList}>
            {tabs.map((tab) => (
              <Button
                key={tab.key}
                className={className(styles.tab, {
                  [styles.active]: activeTab === tab.key,
                })}
                onClick={() => setActiveTab(tab.key)}
              >
                <h2>{tab.label}</h2>
              </Button>
            ))}
          </div>

        </div>
        <div className={styles.content}>
          {tabs.map((tab) =>
            activeTab === tab.key ? <div key={tab.key}>{tab.content}</div> : null
          )}
        </div>
      </div>
    </div>
  );
};

export default Tabs;